import React from 'react'

import { Box, Grid, Typography } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'

import Image from 'artkive/components/Image'
import ContainedSection from 'artkive/components/PageSections/ContainedSection'
import ProductDescriptionItem from 'artkive/components/PageSections/ProductDescriptionItem'
import ProductPriceTypography from 'artkive/components/PageSections/ProductPriceTypography'
import useMobileBreakpoint from 'artkive/hooks/useMobileBreakpoint'
import usePicturesBreakpoints from 'artkive/hooks/usePicturesBreakpoints'
import { PRICING } from 'artkive/utils/constants'

import topSectionBg from 'images/ecom/pricing/bg.svg'
import boxProduct from 'images/ecom/pricing/box.png'
import boxProductMobile from 'images/ecom/pricing/box-mobile.png'

import { productBullets } from './Pricing.constants'

const useStyles = makeStyles(({ breakpoints }) => ({
  wrapper: {
    background: `url(${topSectionBg}) center bottom no-repeat`,
    backgroundSize: 'cover',
    height: 660,
    overflow: 'hidden',
    [breakpoints.down('sm')]: {
      height: 'auto',
    },
  },
  title: {
    marginBottom: 24,
    textAlign: 'center',
    [breakpoints.up('md')]: {
      textAlign: 'left',
      marginBottom: 16,
    },
  },
  imageWrapper: {
    display: 'flex',
    position: 'relative',
    [breakpoints.down('md')]: {
      justifyContent: 'center',
    },
  },
  image: {
    objectFit: 'contain',
    height: '100%',
    width: '100%',
    maxWidth: 'unset',
  },
}))

const TopSection = () => {
  const classes = useStyles()
  const isMobile = useMobileBreakpoint()
  const { mediaUp } = usePicturesBreakpoints()

  return (
    <ContainedSection className={classes.wrapper} disableGutters={isMobile} py={0}>
      <Grid container direction={isMobile ? 'column' : 'row'}>
        <Grid item xs={12} md={6} className={classes.imageWrapper}>
          <picture>
            <source srcSet={boxProduct} media={mediaUp('md')} />
            <Image src={boxProductMobile} className={classes.image} loading='eager' />
          </picture>
        </Grid>
        <Grid item xs={12} md={6}>
          <Box px={isMobile ? 2 : 10} py={isMobile ? 0 : 12.5}>
            <Typography gutterBottom variant='h2' className={classes.title}>
              It All Starts
              <br />
              With An Artkive Box
            </Typography>
            {productBullets.map(({ text }, index) => (
              <ProductDescriptionItem key={index}>{text}</ProductDescriptionItem>
            ))}
            <Box
              display='inline-flex'
              mt={isMobile ? 2 : 2}
              mb={isMobile ? 2 : 0.5}
              alignItems='baseline'
              justifyContent={isMobile ? 'center' : 'flex-start'}
              width='100%'
            >
              <ProductPriceTypography>${PRICING.box.base}</ProductPriceTypography>
            </Box>
            <Box mb={4} textAlign={isMobile ? 'center' : 'left'}>
              <Typography variant='caption'>
                The ${PRICING.box.base} fee covers the physical box and shipping. Digitization, books, and mosaics are
                billed separately and will be included in your final order total. See the pricing details below.
              </Typography>
            </Box>
          </Box>
        </Grid>
      </Grid>
    </ContainedSection>
  )
}

export default TopSection
